module.exports = __webpack_public_path__ + "static/media/event-3.a42a2cd4.jpg";